module.exports = __webpack_public_path__ + "Icono_TipoCX-Bco_512px.png";